import { useCallback, useEffect, useState } from 'react';

import { AxiosResponse } from 'axios';

import { RiskEntitiesOverview } from '../../types/RiskEntities';
import { httpGet } from '../../../../../components/utils';

const useGetRiskEntitiesOverview = () => {
    const [data, setData] = useState<RiskEntitiesOverview>();
    const [isFetching, setIsFetching] = useState<boolean>(false);
    const [error, setError] = useState<string>();

    const fetchRiskEntitiesOverview = useCallback(async () => {
        setIsFetching(true);
        setError(undefined);

        try {
            const response = (await httpGet(
                '/risk-entities/overview'
            )) as unknown as AxiosResponse<RiskEntitiesOverview>;

            setData(response.data);
        } catch (err) {
            setError('Failed to fetch risk entities overview');
        }

        setIsFetching(false);
    }, []);

    useEffect(() => {
        fetchRiskEntitiesOverview();
    }, [fetchRiskEntitiesOverview]);

    return { data, isFetching, error, refetch: fetchRiskEntitiesOverview };
};

export default useGetRiskEntitiesOverview;
